// extracted by mini-css-extract-plugin
export default {"tldBadge":"DomainBundle-tldBadge_Av2TT"};